import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  abs22kdeprm0tm5i as abs,
  roundToLong2s902lrwaad4n as roundToLong,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  dividelr0uqtdj497z as divide,
  modulooi4g1kq3dmtt as modulo,
  toNumber2e2hj9zugjwi2 as toNumber,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  multiply2k9eolhnz1bjv as multiply,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  reversed3umwqsxpi431x as reversed,
  chunked3v1tthtda414w as chunked,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  reversed22y3au42jl32b as reversed_0,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  toString1n9qg6fb0b5i8 as toString_0,
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  Char19o2r8palgjof as Char,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { padStart36w1507hs626a as padStart } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { InlineClassDescriptor2odlvyasjrmr0 as InlineClassDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { LongSerializer_getInstancepwtz4tlewrfw as LongSerializer_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _Cents___init__impl__6gjhxu(inCents) {
  return inCents;
}
function _Cents___get_inCents__impl__osbjn($this) {
  return $this;
}
function Cents__compareTo_impl_jg87bs($this, other) {
  return compareTo(_Cents___get_inCents__impl__osbjn($this), _Cents___get_inCents__impl__osbjn(other));
}
function Cents__compareTo_impl_jg87bs_0($this, other) {
  return Cents__compareTo_impl_jg87bs($this.inCents_1, other instanceof Cents() ? other.inCents_1 : THROW_CCE());
}
function Cents__toString_impl_ko5hxm($this, absolute, forceCents, thousandsSeparator, decimalSeparator) {
  // Inline function 'com.lightningkite.services.data.Cents.toDollarsAndCents' call
  // Inline function 'kotlin.math.absoluteValue' call
  var this_0 = _Cents___get_inCents__impl__osbjn($this);
  // Inline function 'kotlin.Long.div' call
  var this_1 = abs(this_0);
  var tmp0 = divide(this_1, fromInt(100));
  // Inline function 'kotlin.math.absoluteValue' call
  var this_2 = _Cents___get_inCents__impl__osbjn($this);
  // Inline function 'kotlin.Long.rem' call
  var this_3 = abs(this_2);
  var tmp2 = modulo(this_3, fromInt(100));
  var negative = _Cents___get_inCents__impl__osbjn($this) < 0n;
  // Inline function 'kotlin.text.reversed' call
  var this_4 = tmp0.toString();
  var tmp = toString(reversed(isCharSequence(this_4) ? this_4 : THROW_CCE()));
  var dollars = joinToString(reversed_0(chunked(tmp, 3, Cents$toString$lambda)), toString_0(thousandsSeparator));
  var tmp_0;
  if (tmp2 === 0n && !forceCents) {
    tmp_0 = '$' + dollars;
  } else {
    var cents = padStart(tmp2.toString(), 2, _Char___init__impl__6a9atx(48));
    tmp_0 = '$' + dollars + toString_0(decimalSeparator) + cents;
  }
  var str = tmp_0;
  return negative && !absolute ? '-' + str : str;
}
function Cents__toString$default_impl_dffhix($this, absolute, forceCents, thousandsSeparator, decimalSeparator, $super) {
  absolute = absolute === VOID ? false : absolute;
  forceCents = forceCents === VOID ? false : forceCents;
  thousandsSeparator = thousandsSeparator === VOID ? _Char___init__impl__6a9atx(44) : thousandsSeparator;
  decimalSeparator = decimalSeparator === VOID ? _Char___init__impl__6a9atx(46) : decimalSeparator;
  var tmp;
  if ($super === VOID) {
    tmp = Cents__toString_impl_ko5hxm($this, absolute, forceCents, thousandsSeparator, decimalSeparator);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new (Cents())(tmp_0)).toString_aw7904_k$.call(new (Cents())($this), absolute, forceCents, new (Char())(thousandsSeparator), new (Char())(decimalSeparator));
  }
  return tmp;
}
function Cents__toString_impl_ko5hxm_0($this) {
  return Cents__toString$default_impl_dffhix($this, false, false);
}
function Cents__toDouble_impl_mg3etm($this) {
  // Inline function 'kotlin.Long.div' call
  var this_0 = _Cents___get_inCents__impl__osbjn($this);
  return toNumber(this_0) / 100.0;
}
function Cents__plus_impl_qsv4s8($this, other) {
  return _Cents___init__impl__6gjhxu(add(_Cents___get_inCents__impl__osbjn($this), _Cents___get_inCents__impl__osbjn(other)));
}
function Cents__minus_impl_j8lyu0($this, other) {
  return _Cents___init__impl__6gjhxu(subtract(_Cents___get_inCents__impl__osbjn($this), _Cents___get_inCents__impl__osbjn(other)));
}
function Cents__times_impl_lj4j3i($this, other) {
  // Inline function 'kotlin.Long.times' call
  var this_0 = _Cents___get_inCents__impl__osbjn($this);
  var tmp$ret$0 = multiply(this_0, fromInt(other));
  return _Cents___init__impl__6gjhxu(tmp$ret$0);
}
function Cents__times_impl_lj4j3i_0($this, other) {
  // Inline function 'kotlin.Long.times' call
  var this_0 = _Cents___get_inCents__impl__osbjn($this);
  var tmp$ret$0 = toNumber(this_0) * other;
  return _Cents___init__impl__6gjhxu(roundToLong(tmp$ret$0));
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      get_cents_h79cit_k$(_this__u8e3s4) {
        return _Cents___init__impl__6gjhxu(_this__u8e3s4);
      }
      get_cents_3bbzqx_k$(_this__u8e3s4) {
        return _Cents___init__impl__6gjhxu(fromInt(_this__u8e3s4));
      }
      get_dollars_6ygubx_k$(_this__u8e3s4) {
        // Inline function 'kotlin.Long.times' call
        var this_0 = fromInt(_this__u8e3s4);
        var tmp$ret$0 = multiply(this_0, fromInt(100));
        return _Cents___init__impl__6gjhxu(tmp$ret$0);
      }
      get_dollars_vjjqkb_k$(_this__u8e3s4) {
        return _Cents___init__impl__6gjhxu(roundToLong(_this__u8e3s4 * 100));
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.services.data.Cents', this);
        tmp0_serialDesc.addElement_5pzumi_k$('inCents', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_1d7bn5_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeLong_vlw3uq_k$(_Cents___get_inCents__impl__osbjn(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_1d7bn5_k$(encoder, value instanceof Cents() ? value.inCents_1 : THROW_CCE());
      }
      deserialize_ph5qqz_k$(decoder) {
        return _Cents___init__impl__6gjhxu(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeLong_jzt186_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (Cents())(this.deserialize_ph5qqz_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [LongSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function Cents__hashCode_impl_slsn8n($this) {
  return getBigIntHashCode($this);
}
function Cents__equals_impl_xd2wjh($this, other) {
  if (!(other instanceof Cents()))
    return false;
  if (!($this === other.inCents_1))
    return false;
  return true;
}
function Cents$toString$lambda(it) {
  return reversed(it);
}
var CentsClass;
function Cents() {
  if (CentsClass === VOID) {
    class $ {
      constructor(inCents) {
        this.inCents_1 = inCents;
      }
      compareTo_n2t432_k$(other) {
        return Cents__compareTo_impl_jg87bs(this.inCents_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return Cents__compareTo_impl_jg87bs_0(this, other);
      }
      toString() {
        return Cents__toString_impl_ko5hxm_0(this.inCents_1);
      }
      hashCode() {
        return Cents__hashCode_impl_slsn8n(this.inCents_1);
      }
      equals(other) {
        return Cents__equals_impl_xd2wjh(this.inCents_1, other);
      }
    }
    initMetadataForClass($, 'Cents', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance});
    CentsClass = $;
  }
  return CentsClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Cents as Cents1lsbs5l1tlgw,
  _Cents___init__impl__6gjhxu as _Cents___init__impl__6gjhxu21pac6t02ivb3,
  Cents__compareTo_impl_jg87bs as Cents__compareTo_impl_jg87bs1a0ekdl2mvgbq,
  Cents__hashCode_impl_slsn8n as Cents__hashCode_impl_slsn8n2ym5pwri0ohtt,
  _Cents___get_inCents__impl__osbjn as _Cents___get_inCents__impl__osbjn36wwmf018zvn3,
  Cents__minus_impl_j8lyu0 as Cents__minus_impl_j8lyu02ourtksxcdmf8,
  Cents__plus_impl_qsv4s8 as Cents__plus_impl_qsv4s83hvgnvnlu2892,
  Cents__times_impl_lj4j3i as Cents__times_impl_lj4j3i23cyujloetmye,
  Cents__times_impl_lj4j3i_0 as Cents__times_impl_lj4j3iqx8daabo6nal,
  Cents__toDouble_impl_mg3etm as Cents__toDouble_impl_mg3etm3dxlfojyivr3o,
  Cents__toString_impl_ko5hxm_0 as Cents__toString_impl_ko5hxm1a9pwstsznn43,
  Cents__toString$default_impl_dffhix as Cents__toString$default_impl_dffhixgwhghxlriorf,
  $serializer_getInstance as $serializer_getInstance33z4kgxgrgb0n,
  Companion_instance as Companion_instance1c40ds0jrup2e,
};
//endregion

//# sourceMappingURL=Cents.mjs.map
